<template>

  <b-card  class="covercol">
    <!-- template v-slot:header>
      <div class="card-custom-title">
        <h5 class="h3 mb-0">Your Cover Layoput # {{ cover.pos }}</h5>
      </div>
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center">
          <a href="#">
            <b-img :src="designer.profile_image" class="avatar" />
          </a>
          <div class="mx-3">
            <h5 class="h3 mb-0">Your cover proposal # {{ cover.pos }}</h5>
            <a href="#" class="text-dark font-weight-600 text-sm">by {{ designer.name }}</a>
            
          </div>
        </div>
        <div class="text-right ml-auto">
          <base-button icon class="btn-pink" @click="changeCover">
                <span class="btn-inner--icon text-white"><i class="ni ni-chat-round"></i></span>
                <span class="btn-inner--text text-white">Request a change</span>
          </base-button>
          <base-button icon class="btn-dark" @click="changeCover">
                <span class="btn-inner--icon text-white"><i class="ni ni-cloud-download-95"></i></span>
                <span class="btn-inner--text text-white">Download PDF</span>
          </base-button>
        </div>
      </div>
    </template -->

    
    <div>
      <b-row>
        <div class="loader" v-if="loading"></div>

        <b-col v-if="!change" lg="12">
          <b-img v-if="!loading" alt="Cover Layout" :src="buildUrl(cover)" rounded fluid />
          <!-- b-img-lazy class="coverthumb" :src="buildUrl(cover)" alt=""></b-img-lazy -->
        </b-col>

        <b-col v-if="change" sm="6">

          <b-img v-if="!loading" alt="Image placeholder" :src="buildUrl(cover)" rounded fluid />

        </b-col>

        <b-col v-if="change" sm="6">
          <!-- Comments -->
          <div class="mb-1">

            <!-- div v-for="(comment, index) in comments" v-bind:key="comment.id">
              {{ comment.comment.body }}    
              {{ comment.body }}        
            </div -->

            <comments :commentable_id="imageId" commentable_type="PhotoBookImage"></comments>

          </div>
        </b-col>
      </b-row>

    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Modal, BaseAlert } from '@/components'

import Comments from './Comments';

export default {
  name: "photo-book-cover-preview-card",
  components: {
    Modal,
    BaseAlert,
    Comments,
  },
  props: {
    photoBookId: '',
    imageId: '',
    num: 0,
    showComments: false,
  },
  data() {
    return {
      loading: true,
      comments: [],
      designer: '',
      cover: [],
      change: false,
      accepted: false,
      rejected: false,
    };
  },
  methods: {
    changeCover() {
      if (this.change) {
        this.change = false;
        //this.showComments = false;
        console.log("showcomments off -----> "+this.showComments);
      }
      else {
        this.change = true;
        //this.showComments = true;
        console.log("showcomments on-----> "+this.showComments);
      }
      console.log("change will be changed");
    },
    buildUrl(cover) {
      let ht = this.$image_host + cover.image.wallpaper.url; //replace(".png","_s.png");
      return ht
    },
    fetchComments() {
      this.loading = true;
      this.$api.getComments('PhotoBookImage', this.imageId).then((response) => {
        console.log("fetched comments for pic");
        console.log(response);
        this.comments = response.data.comments;

        console.log("comments -> "+this.comments);
        console.log("comments count -> "+this.comments.length);

      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.loading = false;

        console.log("comments -> "+this.comments);
        console.log("comments count -> "+this.comments.length);



        if(this.comments.length > 0){
          //this.showComments = true;
          this.change = true;
//          this.changeCover();
        }
        else{
          this.change = false;
        }
      });
    },
    fetchDesigner() {
      this.loading = true;
      this.$api.getPhotoBookDesigner(this.currentPhotoBook.id).then((response) => {
        //console.log(response);
        this.designer = response.data.designer;

      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    fetchCover() {
      this.loading = true;
      this.$api.getPhotoBookImage(this.photoBookId, this.imageId).then((response) => {
        //console.log("fetched design example pics");
        console.log(response);
        //this.cover = response.data.photo_book_image;
        this.cover = response.data;
        //console.log(this.covers.length);

        console.log(this.cover);

       

      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.loading = false;
       // this.changeCover();
      });
    },

  },
  computed: {
    ...mapGetters({ currentAccount: 'currentAccount', currentPhotoBook: 'currentPhotoBook' }),
  },
  watch: {
    showComments(newValue, oldValue) {
      console.log('queryParameter showComments changed from: ' + oldValue + ' -> ' + newValue);
      this.change = newValue;
      //this.changeCover();

    },
    imageId(newValue, oldValue) {
      console.log('queryParameter imageId changed from: ' + oldValue + ' -> ' + newValue);
      this.fetchCover();
      this.fetchDesigner();
      this.fetchComments();
      // redirect if needed -> dashboard
    },
  },
  mounted() {
    this.fetchCover()
    this.fetchDesigner();
    this.fetchComments();
   // this.changeCover();
    console.log("Mounted bppli:" + this.url);
    console.log("Mounted bppli_id:" + this.num);
  },
};
</script>
<style scoped>
.landscape {
  width: 297mm;
  height: 210mm;

  width: 104px;
  height: 74px;
}

.portrait {
  height: 297mm;
  width: 210mm;

  height: 104px;
  width: 74px;
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.3cm rgba(0, 0, 0, 0.5);
  float: left;
}

.coverthumb {
  width: 100%;
}

.covercol {
  max-width: 90%;
}
</style>